import axios, { type InternalAxiosRequestConfig, AxiosHeaders } from 'axios'

import type { AccessToken } from '@okta/okta-auth-js'

import { Config } from '../config/Config'
import { oktaAuth } from './okta'

const axiosClient = axios.create({
  baseURL: Config.api,
})

const getAccessToken = async () => {
  let { accessToken } = await oktaAuth.tokenManager.getTokens()
  const { expireEarlySeconds } = oktaAuth.tokenManager.getOptions()
  const expirationOffsetFallback = 30
  const expirationOffset = expireEarlySeconds || expirationOffsetFallback
  const timeToSeconds = 1000

  // Normally token is renewed automatically.
  // But it can occur that the token cannot be renewed.
  // For this scenario this fallback is added.
  if (
    accessToken &&
    Math.floor(new Date().getTime() / timeToSeconds) >
      accessToken.expiresAt - expirationOffset
  ) {
    accessToken = (await oktaAuth.tokenManager.renew(
      'accessToken'
    )) as AccessToken
  }

  return accessToken
}

export const requestHandler = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  try {
    const accessToken = await getAccessToken()

    if (!config.headers) {
      config.headers = new AxiosHeaders()
    }

    config.headers.set(
      'Authorization',
      `Bearer ${accessToken?.accessToken ?? accessToken}`
    )

    return config
  } catch (err) {
    window.location.reload()

    return Promise.reject(err)
  }
}

axiosClient.interceptors.request.use(requestHandler)

export { axiosClient as api }
